import { render, staticRenderFns } from "./JrzbSearch.vue?vue&type=template&id=28b6f807&scoped=true"
import script from "./JrzbSearch.vue?vue&type=script&lang=js"
export * from "./JrzbSearch.vue?vue&type=script&lang=js"
import style0 from "./JrzbSearch.vue?vue&type=style&index=0&id=28b6f807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6f807",
  null
  
)

export default component.exports